import { Component, OnInit,Input,EventEmitter, OnChanges, Output,SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService, LayoutService } from '../../';
import { Subscription } from 'rxjs';
import { ArticalModel } from '../../Models/artical-model';
import { DomSanitizer } from '@angular/platform-browser';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-articles-data',
  templateUrl: './articles-data.component.html',
  styleUrls: ['./articles-data.component.scss']
})
export class ArticlesDataComponent implements OnInit,OnChanges {
  article: ArticalModel= new ArticalModel();
  @Input() showTitle: boolean = true;
  @Input() showDetails: boolean = true;
  @Input() newstyletext: boolean = true;

  @Input() articleId: any
  @Output() articleData: EventEmitter<any> = new EventEmitter<any>();
  @Output() articleUrl: EventEmitter<any> = new EventEmitter<any>();

  private subscriptions: Subscription[] = [];

  constructor( private activatedRoute: ActivatedRoute,private sanitizer: DomSanitizer ,
    private meta: Meta,

    private baseService: BaseService,private router: Router,


    ) {
     ;


  }

  ngOnInit(): void {
     this.GetArticle(this.articleId);

     this.baseService.getLangData().subscribe(data => {
      this.changeLagView(data.lang);

     });

  }
  changeLagView(lang){
    this.lang = lang;
    this.meta.updateTag({name: this.lang=='en'?  this.article.nameEn:  this.article.nameAr,
    content: this.lang=='en'?  this.article.contentEn:  this.article.contentAr});
  }
    lang = this.baseService.currentLang || localStorage.getItem('lang') || 'ar';

  GetArticle(id) {
    let subscription = this.baseService.post('articles/GetArticleDetails', { ID: id })
      .subscribe({
        next: (res: any) => {

          this.article = res.output.ArticlesEntity;
          this.meta.updateTag({name: this.lang=='en'?  this.article.nameEn:  this.article.nameAr,
          content: this.lang=='en'?  this.article.contentEn:  this.article.contentAr});
          this.articleUrl.emit(res.output.ArticlesEntity.articleUrl);

        }
        , error: (error: string) => {
           ;
        }
      });
    this.subscriptions.push(subscription);
  }
ngOnChanges(changes: SimpleChanges): void {
 // this.GetArticle(this.articleId);

}
}
